import { FilterProperty } from "./types";

export const TABLE_ITEMS = [
  { label: "Order Number", property: FilterProperty.OrderNumber },
  { label: "Sku", property: FilterProperty.Sku },
  { label: "Product", property: FilterProperty.ProductName },
  { label: "Location", property: FilterProperty.Location },
  { label: "Category", property: FilterProperty.Category },
  { label: "Condition", property: FilterProperty.Condition },
  { label: "Warranty Till", property: FilterProperty.WarrantyTill },
  { label: "Service State", property: FilterProperty.ServiceState },
];

export const TABLE_ITEMS_LABELS = {
  [FilterProperty.OrderNumber]: "Order Number",
  [FilterProperty.Sku]: "Sku",
  [FilterProperty.ProductName]: "Product",
  [FilterProperty.Location]: "Location",
  [FilterProperty.Category]: "Category",
  [FilterProperty.Condition]: "Condition",
  [FilterProperty.WarrantyTill]: "Warranty Till",
  [FilterProperty.ServiceState]: "Service State",
};
